import React, { useEffect } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import CartDrawer from '../components/cart/CartDrawer';
import { Link } from 'react-router-dom';
import { Shield, CheckCircle2, Award, Cpu, ArrowRight } from 'lucide-react';
import { siteImages } from '../data/mock';

const QualityGuaranteePage = () => {
  useEffect(() => {
    document.title = 'Quality Guarantee | EC Pedal Works';
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CartDrawer />
      
      <main className="">
        {/* Banner Section */}
        <section className="relative h-64 md:h-80 overflow-hidden">
          <div className="absolute inset-0">
            <img 
              src={siteImages.featuredBackground}
              alt="Quality Guarantee"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-white via-white/85 to-white/40" />
          </div>
          <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-orange-50 border border-orange-200 rounded-full text-orange-600 text-xs font-semibold mb-4">
                <Shield className="w-3.5 h-3.5" />
                OUR COMMITMENT
              </div>
              <h1 className="font-display text-4xl md:text-5xl text-gray-900 font-extrabold mb-3">
                Quality Guarantee
              </h1>
              <p className="text-gray-600 max-w-lg">
                Our commitment to providing the best bike accessories and cycling gear
              </p>
            </div>
          </div>
        </section>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          {/* Main Guarantee */}
          <div className="bg-gray-50 border border-gray-200 rounded-2xl p-8 md:p-12 mb-16 text-center">
            <div className="w-20 h-20 bg-gradient-to-br from-athletic-500 to-athletic-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <Award className="w-10 h-10 text-gray-900" />
            </div>
            <h2 className="font-display text-3xl lg:text-4xl text-gray-900 font-extrabold mb-6">
              Our Quality Promise
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed max-w-3xl mx-auto">
              At EC Pedal Works, we stand behind every product we sell. We carefully select and test all of our bike accessories and cycling gear to ensure it meets our high standards for quality, durability, and performance. If you're not completely satisfied, we'll make it right.
            </p>
          </div>

          {/* Quality Standards */}
          <div className="grid md:grid-cols-3 gap-6 mb-16">
            {[
              { icon: Shield, title: 'Tested Products', desc: 'Every product is tested for quality and performance before we add it to our catalog.' },
              { icon: CheckCircle2, title: '30-Day Returns', desc: 'Not satisfied? Return any unused item within 30 days for a full refund.' },
              { icon: Award, title: 'Premium Quality', desc: 'We only offer products that meet our strict quality standards.' },
            ].map((item, i) => (
              <div key={i} className="bg-gray-50 border border-gray-200 rounded-2xl p-6 text-center hover:border-athletic-500/50 transition-all group">
                <div className="w-14 h-14 bg-orange-50 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:bg-athletic-500/20 transition-colors">
                  <item.icon className="w-7 h-7 text-orange-600" />
                </div>
                <h3 className="font-display font-bold text-gray-900 text-lg mb-2">{item.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

          {/* What We Guarantee */}
          <div className="bg-gray-50 border border-gray-200 rounded-2xl p-8 md:p-12 mb-16">
            <h2 className="font-display text-2xl font-bold text-gray-900 mb-8 text-center">
              What We Guarantee
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              {[
                'Products as described on our website',
                'Quality materials and construction',
                'Fast, secure shipping',
                '30-day money-back guarantee',
                'Secure payment processing',
                'Responsive customer support',
                'Original products, no counterfeits',
                'Safe packaging and handling',
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3 p-4 bg-gray-100 rounded-xl">
                  <CheckCircle2 className="w-5 h-5 text-orange-600 flex-shrink-0" />
                  <span className="text-gray-900 font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="text-center bg-gradient-to-br from-athletic-500/10 to-athletic-600/10 border border-orange-200 rounded-2xl p-12">
            <h2 className="font-display text-3xl font-extrabold text-gray-900 mb-4">
              Shop with Confidence
            </h2>
            <p className="text-gray-600 mb-8 max-w-xl mx-auto">
              Experience our commitment to quality. Every purchase is backed by our satisfaction guarantee.
            </p>
            <Link 
              to="/shop"
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-athletic-500 to-athletic-600 text-gray-900 font-bold uppercase tracking-wider rounded-xl hover:from-athletic-400 hover:to-athletic-500 transition-all shadow-lg"
            >
              Shop Now
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default QualityGuaranteePage;
